import React, { useRef, useState } from "react";
import Slider from "react-slick"; // import slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomeContent.css";
import slider1 from "../../Components/Assets/sliderVideo/Phantom_Rovo_1.mp4";
import slider2 from "../../Components/Assets/sliderVideo/Phantom_Rovo_2.mp4";
import slider3 from "../../Components/Assets/sliderVideo/Phantom_Rovo_3.mp4";
import slider4 from "../../Components/Assets/sliderVideo/Phantom_Rovo_4.mp4";
import slider5 from "../../Components/Assets/sliderVideo/Phantom_Rovo_5.mp4";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";

const HeroSection = () => {
  const sliderRef = useRef(null); // Reference for the Slider component
  const videoRefs = useRef([]); // References for the videos
  const [isPlaying, setIsPlaying] = useState(true); // State to track playback

  const handleVideoEnd = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext(); // Move to the next slide when the video ends
    }
  };

  const togglePlayback = () => {
    setIsPlaying((prevState) => {
      const newState = !prevState;

      // Play or pause only the active slide video
      const activeSlide = document.querySelector(
        ".slick-slide.slick-active video"
      );
      if (activeSlide) {
        if (newState) {
          activeSlide.play();
        } else {
          activeSlide.pause();
        }
      }

      // console.log(videoRefs.current); // Log video refs
      // console.log(videoRefs.current.map((video) => video.paused)); // Log paused states
      return newState;
    });
  };

  // content inside the slider
  const slideContent = [
    {
      video: slider1,
      // content: (
      //   <>
      //     <img className="slide-logo" src={pharaohImg} alt="Pharaoh Logo" />
      //     <h2>First time experiencing full body stretching</h2>
      //     <p>Bodyfriend Pharaoneo</p>
      //     <p>Audio Speakers by Bang&Olufsen</p>
      //   </>
      // ),
    },
    {
      video: slider2,
      // content: (
      //   <>
      //     <img className="slide-logo" src={edenImg} alt="Eden Logo" />
      //     <h2>Start of a full body stretching exercise</h2>
      //     <p>Massage Chair Bed - Eden</p>
      //   </>
      // ),
    },
    {
      video: slider3,
      content: null, // No additional content for this slide
    },
    {
      video: slider4,
      // content: (
      //   <>
      //     <h2>New product launch! Medical Pharaoh</h2>
      //     <p>Posture Correction Medical Device - MEDICAL PHARAOH</p>
      //   </>
      // ),
    },
    {
      video: slider5,
      content: null, // No additional content for this slide
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (current) => {
      videoRefs.current.forEach((video, index) => {
        const parentSlide = video.closest(".slick-slide");
        if (index === current) {
          // video.play();
          video.play().catch((err) => console.log("Playback failed:", err));
          parentSlide.setAttribute("aria-hidden", "false"); // Ensure active slide is accessible
        } else {
          video.pause();
          parentSlide.setAttribute("aria-hidden", "true"); // Ensure inactive slides are not accessible
        }
      });
    },
    appendDots: (dots) => (
      <div className="custom-dots-container">
        {dots} {/* Ensure dots are correctly passed here */}
        <div className="play-pause-icon" onClick={togglePlayback}>
          {isPlaying ? (
            <PauseIcon style={{ color: "white", fontSize: 20 }} />
          ) : (
            <PlayArrowIcon style={{ color: "white", fontSize: 20 }} />
          )}
        </div>
      </div>
    ),
  };

  return (
    <section className="hero-section">
      <Slider {...settings} ref={sliderRef}>
        {slideContent.map((slide, index) => (
          <div className="slide" key={index}>
            <video
              className="slider-video"
              src={slide.video}
              muted
              playsInline
              autoPlay
              ref={(el) => {
                if (el && !el.closest(".slick-cloned")) {
                  videoRefs.current[index] = el; // Assign only non-cloned elements
                }
              }}
              onEnded={handleVideoEnd} // Event triggered when video ends
              loop={false} // Disable looping for this functionality
            />
            {slide.content && (
              <div className="slide-content">{slide.content}</div>
            )}
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroSection;
